import styled, { css } from 'styled-components';

import { device } from '@styles/mediaQuery';
import { ChatWithUs, JoinForm } from '@components/organisms';
import { Article, SectionHeader } from '@components/molecules';
import { StyledSection, ContentContainer } from '@components/atoms';

function JoinPageContent() {
  return (
    <Container>
      <Section>
        <SectionHeader
          title="Teamwork"
          src="icons/team.svg"
          justifyContent="center"
        />

        <Article
          align="center"
          wrapWidth="100%"
          wrapAlign="center"
          descriptionMaxWidth="550px"
          title="Apply To Join Our Team"
          description="Join our team and become part of a group dedicated to delivering exceptional value and care to our clients."
        />

        <ContentWrapper>
          <JoinForm />

          <ChatWithUs />
        </ContentWrapper>
      </Section>
    </Container>
  );
}

const Section = styled(StyledSection)`
  background-image: url('/images/backround-image.webp');
  background-repeat: no-repeat;
  background-size: contain;

  display: flex;
  flex-direction: column;

  margin-top: 100px;
  padding: 0 20px;

  min-height: 640px;
  max-width: 1920px;
  margin-bottom: 30px;

  ${device.mobileL(css`
    margin-top: 130px;
    padding: 30px 20px;
  `)}

  ${device.laptopS(css`
    margin-top: 130px;
    padding: 100px 20px;
    margin-bottom: 0;
  `)}
`;

const ContentWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;

  ${device.laptopL(css`
    flex-direction: row;
    justify-content: space-between;
  `)}
`;

const Container = styled(ContentContainer)`
  overflow: hidden;
`;

export default JoinPageContent;
